<template>
  <div class="flag-wrapper das-flag">
    <div class="flag-list-container">
      <div v-show="visible" class="flag-list">
        <template v-for="(dasFlag, index) in dasFlags">
        <label :key="`flag-${index}`">{{ dasFlag[0] }}</label>
        <span :key="`value-${index}`">{{ dasFlag[1] }}</span>
      </template>
      </div>
    </div>

    <div class="flag-label" @click="onFlagLabelClick">
      <label>数采标记</label>
    </div>
  </div>
</template>

<script>
import Constant from '../../model/Constant'

export default {
  name: 'DasFlag',
  data: () => ({
    visible: false
  }),
  computed: {
    dasFlags: () => [['N', '正常']].concat(Object.entries(Constant.DAS_FLAG_MAP))
  },
  methods: {
    onFlagLabelClick () {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="scss">
.flag-wrapper {
  position: fixed;
  font: {
    size: 0.75rem;
  }
  display: grid;
  grid-template-columns: max-content 1.875rem;
  right: 0;
  background-color: #ffffff;
  box-shadow: 0 0 8px 0 rgba(75, 103, 209, .38);

  > .flag-list-container {
    color: #909399;
  }

  > .flag-label {
    display: grid;
    grid-template-columns: auto 0.1875rem;
    color: #409eff;
    background: #ecf5ff;
    box-shadow: 0 2px 5px 0 rgba(75, 103, 209, .38);
    cursor: pointer;

    &:after {
      content: "";
      background: currentColor;
    }

    > label {
      display: flex;
      justify-content: center;
      align-items: center;
      writing-mode: vertical-rl;
      padding: 0.25rem 0.125rem 0.25rem 0.3125rem;
      text-align: center;
      cursor: inherit;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/DasFlag.vue